<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'title',
                label: 'Title',
                sortable: true,
                searchable: true,
            },
            {
                value: 'email',
                label: 'Email',
                sortable: true,
                searchable: true,
            },
            {
                value: 'username',
                label: 'Username',
                sortable: true,
                searchable: true,
            },
            {
                value: 'roles',
                label: 'Roles',
                sortable: false,
                searchable: true,
                display: 'name',
            },
            {
                value: 'groups',
                label: 'Groups',
                sortable: false,
                searchable: true,
                display: 'name',
            },
            {
                value: 'with_mobile_features',
                fetchAllAttribute: 'mobile_features',
                label: 'Features',
                sortable: false,
                searchable: true,
                display: 'name',
            },
            {
                value: 'confirmed',
                label: 'Confirmed',
                sortable: true,
                searchable: true,
                customCell: 'UsersConfirmedCell',
            },
        ]"
        :title="'Users'"
        :model="'users'"
        :createText="'Add User'"
        :options="['editable', 'deletable', 'importable']"
        :multiItemActions="['UserGroupsActionButton']"
        data-test-id="users-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
